<template>

<div>
       
<template v-if="slidesdata && slidesdata.length">

         <template v-for="(row0,i0) in slidesdata">

       

            <!-- are there any slides at all
            <div class="slide" v-if="slidesdata.length==0">
                    <div class="grid-x">
                        <h5 class="cell text-center">Welcome to Oddsgalore</h5>
                        <div class="cell">We compare and analyse bookmaker and exchange odds</div>
                        <div class="cell">You can personalise what odds you see and how you see them</div>
                        <div class="cell">We bring you all the latest hints, odds spots and gossip</div>
                        <div class="cell">And the best new and existing customer bookmakerpromotions</div>
                    </div>
                </div> -->

          

            <!-- This uses same feed as main slider-->
            
                    <template v-if="row0.slide[0].slidertype=='X'"> 
                    <SsrCarousel  ref="carousel" :slides-per-page="1" :loop="true" :autoplay-delay="10" :key="i0">
                        <!-- split p slider into 3 slides -->
                    
                                   <div class="slide" v-for="(row,i) in row0.slide[0].promos" :key="i">
                                        
                                            <div  style="font-weight: bold" >

                                                <div class="cell small-4" style="font-size:x-small; color:black; font-weight: bold; height:80px " >

                                                    <singleadverts :row="row" :backcolour="row.BackColour" format="smallpromo"></singleadverts>

                                                </div>

                                            </div> 
                              
                                        
                                    </div>
                    </SsrCarousel>
                    
                    </template> 
                    <!-- <template v-if="row0.slide[0].slidertype=='Y'">
                        
                         <div  style="font-weight: bold" :key="(i0+99)">
                       
                            <div @click="HTMLClicked" style="color:black;height:80px;"  v-html="getStaticSlide(row0.slide[0].filedatalocation)"></div>

                         </div>
                    
                    </template>  -->
</template>
</template>
</div>


</template>

<script>


  
   import singleadverts from '/src/components/adverts/singleadverts.vue'

   export default {
        name: "adcarouselnewads",
        components: {
            singleadverts
        },
        data() {
            return {
                images: [],
                slides: null,
                slidesdata: [],

                url: ['/Odds-Analysis','/Past-Bets','/Horses-Mouth'],
                title: ['We analyse the odds', 'Follow our Bets','Look in the Horsesmouth'],
                featurecounter: 0,
                intervalID: undefined,
                page: 0


            }
        },
           async serverPrefetch() {

    
         try {

                let data = this.$store.state.ads;

                 //filter out x and y types (or any types that are not catered for in the body of the code)
                    for (let i = data.length - 1; i >= 0; i--) {
                        const item = data[i].slide[0].slidertype;
                        // Your condition for removal
                        if (!['X','Y'].includes(item)) {
                            data.splice(i, 1);   // removes the element at index i
                        }
                    }

                    this.slidesdata = data
                    

                } catch(error) {
                   console.log(error)
                }
            
        },
        computed: {
            currentIndex: {
                cache: false,
                get() {
                    return this.$refs.carousel ? this.$refs.carousel.currentPage : 0;
                }
            }
        },
        mounted() {
           
           this.pageChange(0); 
            
        },
        created() {
            
            this.getSlideData();
           
        }, 

        methods: {

            HTMLClicked: function (val) {
                //before moving off cancel timer
            
                clearInterval(this.intervalID)
                this.intervalID = undefined;
                this.$router.push(this.url[this.featurecounter-1])
            },


           pageChange: function (page) {

                
                //turn interval on and off if not page 0
                if (page != 0) {
                    //run updateScreen Manually for the first time
                    clearInterval(this.intervalID)
                    this.intervalID == undefined;
                    
                } else {
                    
                    this.intervalID = setInterval(this.updateScreen,2000);  
                }

            },
   
            updateScreen: function() {
                //reset counter if 3
                try {
                if (this.featurecounter == 3) this.featurecounter = 0;
                    document.getElementById('title').innerHTML = this.langConv(this.title[this.featurecounter]);
                this.featurecounter++
                } catch {
                     //run updateScreen Manually for the first time
                     clearInterval(this.intervalID)
                    this.intervalID = undefined;
                }
            },

            getArrayValue: function (arr,value){
                        return arr[0][value]
            },
            imageURL: function (val1, val2) {
                    return val1 + val2
            },


            goToSlide: function (slideNo) {
                this.$refs.carousel.goToPage(slideNo);
            },

            currentSlide: function (slideNo) {

                var bn = false;

                if (slideNo == this.currentIndex) {
                    bn = true;
                }

                return bn;

            },
            getStaticSlide: function (filename) {
               try {

                return require("/public/assets/slides/small" + filename);


               } catch (e) {
                    console.log(e)
                }
            },
            //get data for banners
            getSlideData: function () {

                try {

                //does the country have a language version of the slider 21/12/2023 - Test for Germany only
                var country =  this.$store.state.countryname;

                country = this.backtoEnglish(country);

                this.localJSONLoad(process.env.VUE_APP_DATA + "slider " + country + ".json").then(response => {
                    this.slidesdata = response

               }).catch(error => {
                   
                   console.log(error)
               });

            } catch (e) {
                console.log(e)
            }

            },

            slidesLoaded: function () {
                this.slidesloaded = true;
                this.$emit("slides-loaded");
            }
        }

    }
</script>

<style scoped>

@import "../../style/bkmsmall.css";



    #bg {
        width: 100% !important;
        height: 100% !important;
        background-size: cover !important;
    }

    .slidertext {
        background-color: #0d0b38  ;
        color: white;
        padding:3px;
        font-size: small;
        font-weight: bold;
        border-radius: 10px;
    }

        .slidertextleft {
        font-family:"roboto condensed";
        color: white;
        padding:3px;
        font-size: 12px;
        font-weight:400;
        border-radius: 10px 0px 0px 10px;

    }

    .slidertextright {
      
        color: white;
        padding:3px;
        font-weight: 500;
        font-size: small;
        border-radius: 0px 10px 10px 0px;
    }


    #basicslider {
        
      font-size: 12px;
      
        background-color: rgba(202, 198, 198, 0.4);
        color: #0d0b38;
       
        padding: 6px;

    }

    .currentslider {
       
        border-bottom: 3px solid gold;
        border-radius: 0px 0px 5px 5px;
        border-right: white solid 1px;
        cursor: pointer;
    }

    .noncurrentslider {
     

        border-radius: 0px 0px 5px 5px;
        border-right: white solid 1px;
        cursor: pointer;
    }



.VueCarousel-navigation-button {

    font-size: x-small !important;
}

    .slideheader {position:absolute; left:40px;top: 10px; background-color:#ffcd03;border-radius:20px 20px 20px 20px; padding:4px 10px 4px 15px;font-weight:500; font-size:13px;}

</style>
